import './we-sorry.scss';
import Imgage from '../../../assets/images/no-load.svg';
import Button from '../../atoms/button/button';

const WeSorry = () => {
  return (
    <div className="o-we-sorry">
      <div className="o-we-sorry__content">
        <img
          className="o-we-sorry__content__img"
          src={Imgage}
          alt="we are sorry image"
          title="we are sorry"
        />
        <h1 className="o-we-sorry__content__title">¡Ups! Algo salió mal</h1>
        <p className="o-we-sorry__content__desc">
          En este momento no podemos completar la operación, te recomendamos actualizar la página o
          intentar más tarde
        </p>
        <div className="o-we-sorry__content__btn">
          <Button
            type="link"
            classname="secondary o-we-sorry__content__btn__back"
            text="Volver al inicio"
            isDisabled={false}
            href="/portal-servicios"
          />
        </div>
      </div>
    </div>
  );
};

export default WeSorry;
